import React from "react";
import {Container} from "semantic-ui-react";
import ProductsList from "../../../components/torres/products-components/products-list";

const ProductPage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <ProductsList/>
        </Container>
    );
};

export default ProductPage;
